var cov_ipnm70ww5 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Submit.tsx",
      hash = "20291fb2710a4dd30f391fd3cca0a75afd7041f8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Submit.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 16
        }
      },
      "1": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 50
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 15
        }
      },
      "3": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 10
        }
      },
      "4": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 60
        }
      },
      "5": {
        start: {
          line: 14,
          column: 31
        },
        end: {
          line: 14,
          column: 60
        }
      },
      "6": {
        start: {
          line: 19,
          column: 66
        },
        end: {
          line: 19,
          column: 76
        }
      },
      "7": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 35
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 13,
            column: 16
          }
        },
        loc: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 11
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 60
          }
        }, {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 14,
            column: 60
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 24,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 24,
            column: 32
          }
        }, {
          start: {
            line: 24,
            column: 36
          },
          end: {
            line: 24,
            column: 61
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 17
          },
          end: {
            line: 25,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 17
          },
          end: {
            line: 25,
            column: 41
          }
        }, {
          start: {
            line: 25,
            column: 45
          },
          end: {
            line: 25,
            column: 52
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/Submit.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from '../Button';

var Submit =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Submit, _PureComponent);

  var _super = _createSuper2(Submit);

  function Submit(props) {
    var _this;

    _classCallCheck(this, Submit);

    cov_ipnm70ww5.f[0]++;
    cov_ipnm70ww5.s[0]++;
    _this = _super.call(this, props);
    cov_ipnm70ww5.s[1]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Submit, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this2 = this;

      cov_ipnm70ww5.f[1]++;
      cov_ipnm70ww5.s[2]++;
      e.persist();
      cov_ipnm70ww5.s[3]++;
      setTimeout(function () {
        cov_ipnm70ww5.f[2]++;
        cov_ipnm70ww5.s[4]++;

        if (_this2.props.onSubmit) {
          cov_ipnm70ww5.b[0][0]++;
          cov_ipnm70ww5.s[5]++;

          _this2.props.onSubmit(e.target);
        } else {
          cov_ipnm70ww5.b[0][1]++;
        }
      }, 50);
    }
  }, {
    key: "render",
    value: function render() {
      cov_ipnm70ww5.f[3]++;

      var _ref = (cov_ipnm70ww5.s[6]++, this.props),
          onSubmit = _ref.onSubmit,
          loading = _ref.loading,
          children = _ref.children,
          formStatus = _ref.formStatus,
          other = _objectWithoutProperties(_ref, ["onSubmit", "loading", "children", "formStatus"]);

      cov_ipnm70ww5.s[7]++;
      return (
        /*#__PURE__*/
        React.createElement(Button, Object.assign({
          type: "primary"
        }, other, {
          disabled: (cov_ipnm70ww5.b[1][0]++, other.disabled) || (cov_ipnm70ww5.b[1][1]++, formStatus === 'disabled'),
          loading: (cov_ipnm70ww5.b[2][0]++, formStatus === 'pending') || (cov_ipnm70ww5.b[2][1]++, loading),
          onClick: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21,
            columnNumber: 7
          }
        }), children)
      );
    }
  }]);

  return Submit;
}(PureComponent);

export default Submit;